import { actions } from '../constants/lti';
import * as actionTypes from '../../models/action/lti';
import { IAction } from '../../models/action/core';

import { Log } from 'ng2-logger';

const _logger = Log.create('Lti Add Page');
// #region Add Lti Action
export function addLtiGetAction(data: actionTypes.ILtiData, spinnerId?: string, spinnerType?: 'get'|'set', callback?: (value: boolean) => void): actionTypes.IGetAddLti {
    return {
        ltiData: data,
        timestamp: Date.now(),
        type: actions.ADD_LTI_ACTIVITY,
        spinnerId,
        spinnerType,
        callback
    };
}

// Add Lti Update Get Action
export function updateLtiGetAction(
    dataParams: actionTypes.ILtiParams,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IUpdateLtiGet {
    return {
        ...dataParams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_LTI_UPDATE_ACTIVITY
    };
}

export function setLtiDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_LTI_DATA_DEFAULT
    };
}

export function addLtiSetAction(
    ltiData: actionTypes.ILtiData[] | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.ISetAddLti {
    return {
        ltiData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_LTI_SET_ACTIVITY
    };
}
// #endregion Add Lti Action

// #region Delete Lti Action
export function deleteLtiGetAction(data: actionTypes.IDeleteData): actionTypes.IGetDeleteLti {
    return {
        ltiData: data,
        timestamp: Date.now(),
        type: actions.DELETE_LTI_ACTIVITY
    };
}

export function deleteLtiSetAction(deleteLtiStatus: boolean): actionTypes.ISetDeleteLti {
    return {
        deleteLtiStatus,
        timestamp: Date.now(),
        type: actions.DELETE_LTI_SET_ACTIVITY
    };
}
// #endregion Delete Lti Action

export function launchLti(LtiId: string, EnrollmentId: string): actionTypes.ILaunchLti {
    return {
        LtiId,
        EnrollmentId,
        timestamp: Date.now(),
        type: actions.LAUNCH_LTI
    };
}
